import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Typography, Button, Box } from '@mui/material';

const StepFourteenJoin = (props) => {
  //eslint-disable-next-line
  const [completed, setCompleted] = useState(true);
  let navigate = useNavigate();

  return (
    <React.Fragment>
      <Typography variant='h3' sx={{ mt: '3rem', mb: 1, fontWeight: 'bold' }}>
        You're officially a mentor!
      </Typography>
      <Typography variant='body1' sx={{ mt: '1rem' }}>
        Welcome to The 100 Club!
      </Typography>
      <Typography variant='body1' sx={{ mt: '1rem', fontWeight: 'bold' }}>
        How to edit my profile?
      </Typography>
      <Typography variant='body1'>1. Go to the100club.io</Typography>
      <Typography variant='body1'>2. Login to your account with your email and password</Typography>
      <Typography variant='body1'>3. Edit and update your profile</Typography>
      <Typography variant='body1'>4. Check the mentor directory to see it updated</Typography>

      <Typography variant='body1' sx={{ mt: '1rem' }}>
        Without further ado, we'd also like to invite you to join our private community and interact with founders
        across The 100 Club.
      </Typography>
      <a
        href='https://t.me/+ttRAwM6_kvc1OGFl'
        target='_blank'
        rel='noreferrer'
        onClick={(e) => {
          navigate(`/dashboard`);
        }}>
        <Button color='primary' variant='contained' fullWidth sx={{ mt: '1rem', textDecoration: 'none' }}>
          JOIN TELEGRAM COMMUNITY
        </Button>
      </a>
      <Box sx={{ mt: '1rem', display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button disabled type='submit'>
          Next
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default StepFourteenJoin;
